module.exports = __webpack_public_path__ + "img/CROWN PURPLE.ca9f98b.svg";